import React, { useState, useEffect } from 'react'

const InsuranceTripQueueDetail = ({ approvalDetails }) => {
    debugger;
    const [loading, setLoading] = useState(false);
    const booking = approvalDetails?.insurance?.booking;
    const passenger = approvalDetails?.insurance?.passengers;
    const riders = approvalDetails?.insurance?.rider;
    const approval = approvalDetails?.requestedApprovals;

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        if (isNaN(date)) return "-";
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const [timeLeft, setTimeLeft] = useState("");
    const getRemainingTime = (blockedOn) => {
        try {
            if (!blockedOn) return "Error";

            const blockTime = new Date(blockedOn);

            if (isNaN(blockTime)) return "Invalid Date";

            // Add 6 minutes
            const expiryTime = new Date(blockTime.getTime() + 6 * 60000);

            const diff = expiryTime - new Date();

            if (diff <= 0) return "Expired";

            const m = Math.floor(diff / 60000);
            const s = Math.floor((diff % 60000) / 1000);

            return `${m}m ${s}s left`;
        } catch (error) {
            return "Error";
        }
    };

    const blockedOn = approvalDetails?.booking?.blockedOn;
    useEffect(() => {
        if (!blockedOn) {
            setTimeLeft("No Time");
            return;
        }
        setTimeLeft(getRemainingTime(blockedOn));
        const interval = setInterval(() => {
            setTimeLeft(getRemainingTime(blockedOn));
        }, 1000);
        return () => clearInterval(interval);
    }, [blockedOn]);

    const formatDateTime = (dateStr) => {
        if (!dateStr) return "-";

        const date = new Date(dateStr);

        if (isNaN(date.getTime())) return "-";

        return date
            .toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })
            .replace(",", "")
            .replace("am", "AM")
            .replace("pm", "PM");
    };

    return (
        <>
            <section className='wraper'>
                <div className='box_shadow mt-16'>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "10px 14px",
                            marginBottom: "15px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            background: timeLeft === "Expired" ? "#f8d7da" : "#e7f3ff",
                            color: timeLeft === "Expired" ? "#842029" : "#084298",
                            borderLeft: `4px solid ${timeLeft === "Expired" ? "#dc3545" : "#0d6efd"}`,
                            zIndex: 10,
                            position: "relative"
                        }}
                    >
                        <span>⏳</span>
                        <span style={{ fontWeight: "600" }}>Booking Time:</span>
                        <span style={{ fontWeight: "700" }}>
                            {timeLeft === "Expired" ? "Session Expired" : timeLeft || "Calculating..."}
                        </span>
                    </div>
                    {/* Reason */}
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Reason For Travel</h4>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Trip ID</div>
                                <div className="labl_detls">{approval?.referenceNo || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Travel Mode</div>
                                <div className="labl_detls">{booking.travelPurpose} Travel</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Employee ID</div>
                                <div className="labl_detls">{approval?.employeeId || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Employee Name</div>
                                <div className="labl_detls">{approval?.travellerName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Billing Entity</div>
                                <div className="labl_detls">{approvalDetails?.corporateDetails?.companyName || "-"}</div>
                            </div>
                        </div>

                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Insurance Info</h4>
                        </div>
                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Category</div>
                                <div className="labl_detls">{booking?.categoryName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Insurance Name</div>
                                <div className="labl_detls">{booking?.insuranceName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Start Date</div>
                                <div className="labl_detls">{booking?.startDate || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">End Date</div>
                                <div className="labl_detls">{booking?.endDate || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Plan Name</div>
                                <div className="labl_detls">{booking?.planName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Supplier Name</div>
                                <div className="labl_detls">{booking?.supplierName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Total Premium</div>
                                <div className="labl_detls">{booking?.totalPremium || "-"}</div>
                            </div>
                        </div>

                        {/* <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Total Fare</div>
                                <div className="labl_detls text-danger">
                                    ₹ {fare?.totalFare || 0}
                                </div>
                            </div>
                        </div> */}
                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Policy Status</div>
                                <div
                                    className="labl_detls"
                                    style={{
                                        color: booking?.policyStatus === "OutOfPolicy" ? "red" : "green",
                                        fontWeight: "600"
                                    }}
                                >
                                    {booking?.policyStatus || "-"}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Policy Reason</div>
                                <div className="labl_detls" style={{ color: "red" }}>{booking?.policyReason || "-"}</div>
                            </div>
                        </div>
                    </div>

                    {/* {passenger && passenger.length > 0 && (
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="headings">Passenger Details</h4>
                            </div>

                            {passenger.map((item, index) => (
                                <React.Fragment key={index}>

                                    <div className="col-md-6">
                                        <div className="d-flex mb-3">
                                            <div className="labl">Passenger Name</div>
                                            <div className="labl_detls">
                                                {item?.title} {item?.firstName} {item?.lastName}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="d-flex mb-3">
                                            <div className="labl">Gender</div>
                                            <div className="labl_detls">
                                                {item?.gender || "-"}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="d-flex mb-3">
                                            <div className="labl">Age</div>
                                            <div className="labl_detls">
                                                {item?.age || "-"}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="d-flex mb-3">
                                            <div className="labl">Mobile</div>
                                            <div className="labl_detls">
                                                {item?.mobile || "-"}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="d-flex mb-3">
                                            <div className="labl">Email</div>
                                            <div className="labl_detls">
                                                {item?.email || "-"}
                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>
                            ))}
                        </div>
                    )} */}

                    {passenger && passenger.length > 0 && (
                        <>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Passenger Details</h4>
                                </div>
                                {passenger && passenger.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <div className='col-md-12 row'>
                                            <div class="d-flex mb-3">
                                                <div class="labl">Passenger Name </div>
                                                <div class="labl_detls">{item?.title} {item?.firstName} {item?.lastName}</div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </>
                    )}

                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="headings">Approvals</h4>
                        </div>

                        {/* ================= REQUEST ================= */}
                        <div className="col-md-12">
                            <div className="d-flex mb-3">
                                <div className="labl">Requested By</div>
                                <div className="labl_detls">
                                    {approval?.userId || "-"}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Submitted On</div>
                                <div className="labl_detls">
                                    {formatDateTime(approval?.createdOn)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Remark</div>
                                <div className="labl_detls">
                                    {approval?.remark || "-"}
                                </div>
                            </div>
                        </div>
                        {/* ================= LEVEL 1 ================= */}
                        <div className="col-md-12 mt-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="mb-3">
                                    <span className="badge bg-secondary me-2">LEVEL 1</span>
                                    First Level Approval
                                </h5>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="d-flex mb-3">
                                <div className="labl">Approver(s)</div>
                                <div className="labl_detls">
                                    <span className="badge bg-light text-dark border">
                                        {approval?.level1ApproverName || "-"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="d-flex mb-3">
                                <div className="labl">Action By</div>
                                <div className="labl_detls">
                                    {approval?.level1ActionBy || "-"}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="d-flex mb-3">
                                <div className="labl">Action On</div>
                                <div className="labl_detls">
                                    {formatDateTime(approval?.level1ActionOn)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="d-flex mb-3">
                                <div className="labl">Status</div>
                                <div className="labl_detls">
                                    <span className="badge bg-warning text-dark">
                                        {approval?.level1ApprovalStatus || "Requested"}
                                    </span>
                                </div>
                            </div>
                        </div>


                        {/* ================= LEVEL 2 ================= */}
                        {approval?.level2ApproverName?.trim() && (
                            <>
                                <div className="col-md-12 mt-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="mb-3">
                                            <span className="badge bg-secondary me-2">LEVEL 2</span>
                                            Second Level Approval
                                        </h5>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Approver(s)</div>
                                        <div className="labl_detls">
                                            {approval?.level2ApproverName ? (
                                                <span className="badge bg-light text-dark border">
                                                    {approval.level2ApproverName}
                                                </span>
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Action By</div>
                                        <div className="labl_detls">
                                            {approval?.level2ActionBy || "-"}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Action On</div>
                                        <div className="labl_detls">
                                            {formatDateTime(approval?.level2ActionOn)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Status</div>
                                        <div className="labl_detls">
                                            <span className="badge bg-warning text-dark">
                                                {approval?.level2ApprovalStatus || "Requested"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

export default InsuranceTripQueueDetail